module.exports = __webpack_public_path__ + "img/drug-31.efcc4ca5.png";